import { cardListAPI } from '../fetchCardListByHolderOrAccount.service';
import { cardAPI } from '../../cardAPI.service';

export const updateQueryOneCard = ({
                                     locale,
                                     cardNo,
                                     newOneCard,
                                   }: any) => cardAPI.util.updateQueryData('fetchOneCardByAccount',
  ({ locale, cardNo }), (draft: any) => {
    Object.assign(draft, { ...newOneCard });
  });


export const updateQueryListCard = ({
                                      locale,
                                      holderId,
                                      accountId,
                                      newCards,
                                    }: any) => cardListAPI.util.updateQueryData('fetchCardListByHolderOrAccount',
  ({ locale, holderId, accountId }), (draft: any) => {
    Object.assign(draft, { cards: newCards });
  });
